import React from 'react';
import Card, { CardBody, CardHeader, CardLabel, CardTitle, CardSubTitle } from '../../bootstrap/Card';
import { profilePic, pictNotLoading } from '../../../services/common.service';

interface StudentProfileCardProps {
	studentProfileData: any;
	children?: React.ReactNode;
}

const StudentProfileCard: React.FC<StudentProfileCardProps> = ({ studentProfileData, children }) => {
	if (!studentProfileData) {
		return null;
	}

	return (
		<Card stretch>
			<CardHeader borderSize={1}>
				<CardLabel icon='Person' iconColor='info'>
					<CardTitle tag='div' className='h5'>
						Account Details
					</CardTitle>
					<CardSubTitle tag='div' className='h6'>
						Personal Information
					</CardSubTitle>
				</CardLabel>
			</CardHeader>
			<CardBody>
				<div className='row g-3'>
					<div className='col-12'>
						<div className='row align-items-center'>
							<div className='col-auto text-center'>
								<img
									style={{ borderRadius: '50%', objectFit: 'cover' }}
									src={
										studentProfileData.profilePath != null
											? studentProfileData.profilePath
											: profilePic(studentProfileData.genderId)
									}
									height='90'
									width='90'
									onError={(e: any) => pictNotLoading(e, studentProfileData.genderId)}
									alt='Student Profile'
								/>
							</div>
							<div className='col'>
								<h5 className='fs-5 fw-bold me-2 text-uppercase mb-1'>
									{studentProfileData.studentName}
								</h5>
								<div className='mb-1'>
									<span className='badge bg-l12-success text-success fw-bold me-2'>
										{studentProfileData.admissionNo}
									</span>
									<span className='text-muted small'>
										Sem - {studentProfileData.semesterNumber}
									</span>
								</div>
								<div className='text-muted small fw-semibold'>{studentProfileData.courseName}</div>
								<div className='text-muted small'>{studentProfileData.departmentName}</div>
								<div className='text-muted small'>{studentProfileData.batchName}</div>
							</div>
						</div>
					</div>
					{children}
				</div>
			</CardBody>
		</Card>
	);
};

export default StudentProfileCard;
